import React from "react";

function Banner({ styles, language, onContinue }) {
  return (
    <div className={styles.banner}>
      <p
        style={{
          fontSize: "16px",
          color: "white",
          fontWeight: "700",
          marginBlock: "0",
        }}
      >
        {language?.energy_certificate_available_almost_done}
      </p>
      <p
        style={{
          fontSize: "28px",
          fontWeight: "900",
          marginTop: "5px",
          marginBottom: "10px",
        }}
      >
        {language?.energy_certificate_available}
      </p>
      <p>{language?.energy_certificate_available_para_1}</p>
      {language?.energy_certificate_available_para_3 ? (
        <p>
          <b>{language?.energy_certificate_available_para_3}</b>
        </p>
      ) : null}
      <div className={styles.trust}>
        <div className={styles.trustCard}>
          <div className={styles.trustIcon}>🧾</div>
          <div className={styles.trustLabel}>
            {language?.energy_certificate_available_box_1}
          </div>
        </div>
        <div className={styles.trustCard}>
          <div className={styles.trustIcon}>👷‍♂️</div>
          <div className={styles.trustLabel}>
            {language?.energy_certificate_available_box_2}
          </div>
        </div>
        <div className={styles.trustCard}>
          <div className={styles.trustIcon}>📬</div>
          <div className={styles.trustLabel}>
            {language?.energy_certificate_available_box_3}
          </div>
        </div>
        <div className={styles.trustCard}>
          <div className={styles.trustIcon}>🔒</div>
          <div className={styles.trustLabel}>
            {language?.energy_certificate_available_box_4}
          </div>
        </div>
        <div className={styles.trustCard}>
          <div className={styles.trustIcon}>🇩🇪</div>
          <div className={styles.trustLabel}>
            {language?.energy_certificate_available_box_5}
          </div>
        </div>
      </div>
      <p style={{ marginTop: "30px", fontWeight: "600", color: "#000000CC" }}>
        {language?.energy_certificate_available_para_2}{" "}
        <span onClick={onContinue} style={{ color: "#22A156", cursor: "pointer" }}>
          <b>{language?.continue}</b>
        </span>
      </p>
    </div>
  );
}

export default Banner;


